import { theme } from '$theme';
import styled from '@emotion/styled';

export const StyledFacetCheckbox = styled.div({
    label: {
        display: 'block',
        padding: `0 0 ${theme.space[2]}`,
    },
});
